import { Table, Space, Tag, Popover, Tooltip, Drawer } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "./style.css";
import { contactForm } from "../../../api";
import { getTableHeight } from "../../../utils/TableHelpers/TableHeightHelper";
import { LogEvents, LoggerContext } from "../../../context/logging";

const EmpaneledVendors = ({
  vendorList,
  pages,
  fetchVendors,
  setSelectedVendor,
  addVendorToBranch,
}) => {
  const [vendors, setVendors] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(pages);
  const [loading, setLoading] = useState(false);
  const [showId, setShowId] = useState();
  const [arr, setArr] = useState([]);
  const logger = React.useContext(LoggerContext);

  useEffect(() => {
    // vendorList.map((data, index) => {
    //   data.id = index;
    // })
    console.log("vendorList---->", vendorList);
  }, [vendorList]);

  function postContactDetails(data) {
    const formValue = new FormData();

    formValue.append("vendor_id", data.id);
    formValue.append("vendor_contact", data.contact);
    formValue.append("vendor_email", data.email);
    formValue.append("vendor_pincode", data.pincode);

    axios
      .post(`${contactForm}`, formValue)
      .then((res) => {
        console.log(res);
      })
      .catch((res) => {
        console.log(res);
      });
  }

  const columns = [
    {
      title: "Name",
      key: "name",
      dataIndex: "name",
      fixed: "left",
    },
    {
      title: "Contact",
      key: "contact",
      dataIndex: "contact",
      onCell: (data, index) => {
        return {
          onClick: () => {
            setShowId(data.id);

            logger.log(LogEvents.getNumber, {});
            navigator.clipboard.writeText(data.contact);
            postContactDetails(data);
            toast.success("Number copied successfully");
          },
        };
      },
      render: (text, data, index) => (
        <Space>
          {showId !== data.id ? <Tag color={"warning"}>Get Number</Tag> : text}
        </Space>
      ),
    },
    {
      title: "Address",
      key: "address",
      dataIndex: "address",
    },
    {
      title: "Pincode",
      key: "pincode",
      dataIndex: "pincode",
    },
    {
      title: "Email",
      key: "email",
      dataIndex: "email",
    },
    {
      title: "Categories",
      key: "category_name",
      render: (text, data, index) => {
        let categories = "";
        data?.category_name?.map((category) => {
          if (category?.length > 0) {
            categories += category + ", ";
          }
        });
        return (
          <>
            <Tooltip placement="topLeft" title={categories}>
              {data?.category_name?.map((category, index) => {
                if (category?.length > 0 && index < 6) {
                  return <>{category}, </>;
                }
              })}
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "Actions",
      key: "action",
      render: (text, data, index) => (
        <Space>
          <Tag
            color={"cyan"}
            style={{ cursor: "pointer" }}
            onClick={() =>
              addVendorToBranch({
                name: data.name,
                contact: data.contact,
                email: data.email,
                pincode: data.pincode ? data.pincode : "",
                billing_address: data.address ?? "",
                contact_person: "",
                gst: "",
                pan_number: "",
                bank_account_holder: "",
                bank_account_number: "",
                bank_ifsc: "",
                billing_address: "",
              })
            }
          >
            Add to Empanelled Vendors
          </Tag>
          <Tag
            color={"blue"}
            style={{ cursor: "pointer" }}
            onClick={() => setSelectedVendor(data)}
          >
            View Details
          </Tag>
        </Space>
      ),
    },
  ];
  useEffect(() => {
    // fetchVendors({ page: page });
  }, []);

  useEffect(() => {
    setCount(parseInt(pages));
    console.log(vendorList);
  }, [pages]);

  return (
    <>
      <Table
        dataSource={vendorList ?? []}
        columns={columns}
        loading={loading}
        scroll={{
          x: "100%",
          y: getTableHeight({ table_name: "vendor_table_empanelled" }),
        }}
        pagination={{
          total: parseInt(count),
          defaultPageSize: 50,
          defaultCurrent: 1,
          showSizeChanger: false,
          onChange: (page) => {
            fetchVendors({ page: page });
          },
        }}
        // onRow={(record, rowIndex) => {
        //   return {
        //     onClick: (event) => {
        //       setSelectedVendor(record);
        //       console.log("i-log> clicl row ", record);
        //     },
        //   };
        // }}
      />
    </>
  );
};

export default EmpaneledVendors;
